import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}

import Multiselect from "@vueform/multiselect";
import {useOriStore} from "@/stores/oriStore";
import {SelectItem, UploadType, Ori} from "@/types";
import {computed, onMounted, ref, toRef} from "vue";


export default /*@__PURE__*/_defineComponent({
  ...{
    inheritAttrs: false,
},
  __name: 'AgencyInput',
  props: /*@__PURE__*/_mergeModels({
    error: {
        type: String,
        default: null,
    },
    selectFirst: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    excludedOris: {
        type: Array,
    },
    canClear:{
        type: Boolean,
        default: true,
    }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {

const model = _useModel(__props, "modelValue");

const props = __props;
const oriStore = useOriStore();
const emit = __emit;

const agencies = computed(() => {
    let resultOris = oriStore.oris;

    if (props.excludedOris) {
        let excludedOris = props.excludedOris.filter((x) => x != model.value);

        if (excludedOris) {
            resultOris = resultOris.filter((item) => !excludedOris.includes(item.ori));
        }
    }

    let list = resultOris.map(
        (m) =>
            ({
                label: m.oriAgency,
                value: m.ori,
            } as SelectItem)
    );

    return list;
});

onMounted(async () => {
    if (oriStore.dataset != undefined || oriStore.oris?.length == 0) {
        oriStore.reset();
        await oriStore.fetchAll();
    }

    if (props.selectFirst) {
        emit("update:modelValue", oriStore.oris[0].ori);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Multiselect), {
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      options: agencies.value,
      multiple: false,
      "close-on-select": true,
      class: _normalizeClass({'is-invalid': !!__props.error}),
      label: 'label',
      searchable: true,
      "filter-results": true,
      strict: false,
      submit: false,
      "native-support": true,
      "can-clear": __props.canClear
    }, null, 8, ["modelValue", "options", "class", "can-clear"]),
    (__props.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})